import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	checkboxLabel: {
		id: 'personal-settings-preference-fields.common.reporter-role.checkbox-label',
		defaultMessage: "You're the reporter",
		description: 'Label for checkbox which enables or disables role based notification preference',
	},
});
